/**
 * QACheckbox — three-state checkbox (unchecked → pass → fail) used for both
 * per-item checks and the overall sign-off. Extracted from QAPanel.tsx.
 */

import React from 'react';
import type { QAStatus } from './qaTypes';

export const statusColors: Record<QAStatus, string> = {
  unchecked: '#555',
  pass: '#2ecc71',
  fail: '#e74c3c',
};

export const statusSymbols: Record<QAStatus, string> = {
  unchecked: '',
  pass: '\u2713',
  fail: '\u2717',
};

// Exported so tsc can name the component's type in declaration positions
// (non-exported props interfaces trip TS4023 under this repo's config).
export interface QACheckboxProps {
  status: QAStatus;
  onClick: () => void;
}

export const QACheckbox: React.FC<QACheckboxProps> = ({ status, onClick }) => (
  <div
    onClick={onClick}
    style={{
      width: 20,
      height: 20,
      borderRadius: 4,
      border: `2px solid ${statusColors[status]}`,
      background: status === 'unchecked' ? 'transparent' : statusColors[status],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      flexShrink: 0,
      fontSize: 14,
      fontWeight: 'bold',
      color: '#fff',
      transition: 'all 0.15s',
    }}
  >
    {statusSymbols[status]}
  </div>
);
